/*
TheatreSpotStatus is a class-based component that fetches target group spot information and passes it down to the SpotStatus component.

1. It is called in Theatre.js in Spot Status tab
2. It has a default date range filter from today to seven days from today.
*/

import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { createSelector } from "reselect";
import * as constants from "../../../../../../constants";
import { bindDispatch } from "../../../../../../utils";
import WithFetchList from "../../../../../hoc/withFetchList";
import SpotStatus from "../../../../campaigns/common/SpotStatus";
import getSpotStatusDefaultDateRange from "../../../../campaigns/utils/getSpotStatusDefaultDateRange";

class TheatreSpotStatus extends Component {
  componentDidMount = async () => {
    const {
      match: {
        params: { theatreId },
      },
    } = this.props;

    const defaultRange = getSpotStatusDefaultDateRange("theatre", null);

    this.props.fetchData(null, true, [
      { theatreId },
      {
        filters: [
          {
            from: defaultRange.from,
            id: "showDate",
            type: "showDate",
            displayName: defaultRange.displayName,
            to: defaultRange.to,
          },
        ],
      },
    ]);
  };

  render = () => {
    const {
      theatres: { isTheatreSpotStatusLoading, theatreSpots },
    } = this.props;
    return (
      <SpotStatus
        {...this.props}
        data={{
          spotStatus: theatreSpots,
          isLoading: isTheatreSpotStatusLoading,
        }}
      />
    );
  };
}

export const TheatreSpotStatusWithFilters = WithFetchList("getTheatreSpotStatus", {
  sort: [
    {
      id: "showDate",
      desc: false,
    },
  ],
  ps: constants.DEFAULT_PAGE_SIZE,
  page: 1,
  multiColumnSort: false,
})(TheatreSpotStatus);

const mapStateToProps = createSelector(
  (state) => state.theatres,
  (state) => state.userData,
  (theatres, userData) => ({ theatres, userData: userData.user })
);

export default connect(mapStateToProps, bindDispatch)(withRouter(TheatreSpotStatusWithFilters));
